export default {
    props: {
        label: String,
        additionalLabel: String,
        placeholder: String,
        selectClass: String,
        small: String,
        items: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    template: `
    <div class="selectable" :class="{disabled: disabled }">
      <div class="selectable__wrapper">
        <label v-if="label">{{label}} <p>{{additionalLabel}}</p></label>
        <fieldset class="select-holder">
            <select :class="selectClass" :disabled="disabled" @change="selectItem($event)" name="select" v-model="selected">
                <option value="default" class="hideme">{{placeholder}}</option>
                <option :value="select" v-for="(select, index) in items">
                    {{select}}
                </option>
            </select>
        </fieldset>
        <small v-if="small">{{small}}</small>
      <div>
    </div>`,
  data() {
    return {
      selected: ''
    };
  },
  mounted() {
    this.selected = 'default';
  $(`.${this.selectClass}`).val('default');},
  methods: {
    selectDefault() {$(`.${this.selectClass}`).val('default');
      jcf.getInstance($(`.${this.selectClass}`)).refresh();
      this.selected = 'default';
    },
    selectItem(event) {
      if (event.target.value) {
        this.selected = event.target.value;
        this.$emit('select', this.selected);
      }
    },
    clearSelect() {
      this.selected = null;
    }
  },
  watch: {
    selectedId(newVal) {
      this.selectItem(this.items[newVal]);
    }
  }
};


// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/ui/selectable.js